<template>
  <v-container>
    <div style="width: 100%">Dodaj tip rada:</div>
    <v-divider></v-divider>
    <form-two
      :types="types"
      v-on:clearTypes="clearTypes"
      v-on:setSelectedTip="selectTip"
      class="ml-0 pl-0 mr-0 pr-0"
    ></form-two>
    <div style="width: 100%">Dodaj osnovne podatke o radu:</div>
    <v-divider></v-divider>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col :cols="getDeviceType === 'touch' ? 12 : 6">
          <v-text-field
            dense
            v-model="nameCro"
            :rules="[rules.nameRules]"
            label="Unesi naziv rada*"
            required
            outlined
          ></v-text-field>

          <v-text-field
            dense
            v-model="year"
            label="Unesi godinu izdavanja*"
            :rules="[rules.yearRule1, rules.yearRule2]"
            required
            number
            outlined
          ></v-text-field>
          <v-combobox
            dense
            v-model="keywords"
            :items.sync="getKeywords"
            hide-selected
            label="Unesi/Odaberi ključne riječi"
            multiple
            item-text="naziv"
            persistent-hint
            small-chips
            return-object
            :search-input.sync="searchKljucneRijeci"
            outlined
          >
            <template v-slot:selection="{ attrs, item }">
              <v-chip
                small
                v-if="item === Object(item)"
                v-bind="attrs"
                :color="`primary lighten-2`"
              >
                <span class="pr-2">
                  {{ item.naziv }}
                </span>
                <v-icon small @click="removeKR(item)"> mdi-close </v-icon>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        <v-col
          :class="!$vuetify.breakpoint.mdAndUp ? 'pt-0 mt-n3' : ''"
          :cols="getDeviceType === 'touch' ? 12 : 5"
        >
          <v-textarea
            v-if="selected_type !== 'Knjiga'"
            single-line
            auto-grow
            v-model="abstractCro"
            :rules="[rules.abstractRules]"
            outlined
            label="Unesi sažetak*"
            required
            rows="4"
          ></v-textarea>
          <v-textarea
              v-else
              single-line
              auto-grow
              v-model="abstractCro"
              outlined
              label="Unesi sažetak"
              rows="4"
          ></v-textarea>
        </v-col>
      </v-row>
      <div style="width: 100%">Dodaj prijevode rada:</div>
      <v-divider></v-divider>
      <v-row>
        <v-col :cols="getDeviceType === 'touch' ? 12 : 6">
          <v-autocomplete
            dense
            single-line
            :items="getJezici"
            item-text="naziv"
            v-model="odabraniJezik"
            :search-input.sync="searchJezike"
            label="Odaberi jezik prevoda"
            return-object
            outlined
            hide-selected
          >
            <!-- <template v-slot:append-outer="{}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="openDodajJezikDialog" color="primary" dark v-bind="attrs" v-on="on">
                    mdi-plus
                  </v-icon>
                </template>
                <span>Dodaj jezik koji nije na listi</span>
              </v-tooltip>
            </template>  -->
            </v-autocomplete
          >
           <v-btn
            v-if="!$vuetify.breakpoint.mdAndUp"
            text
            x-small
            color="primary"
            class="mt-n12"
            @click="openDodajJezikDialog"
            >Dodaj jezik koji nije na listi</v-btn
          >
          <v-text-field
            dense
            outlined
            v-model="nameEng"
            label="Unesi naziv rada na odabranom jeziku"
          ></v-text-field>
          <v-btn
            v-if="$vuetify.breakpoint.mdAndUp"
            text
            x-small
            color="primary"
            class="mt-n12"
            @click="openDodajJezikDialog"
            >Dodaj jezik koji nije na listi</v-btn
          >
        </v-col>
        <v-col
          :cols="getDeviceType === 'touch' ? 12 : 5"
          :class="!$vuetify.breakpoint.mdAndUp ? 'pt-0 mt-n3' : ''"
        >
          <v-textarea
            dense
            single-line
            auto-grow
            outlined
            v-model="abstractEng"
            label="Unesi sažetak na odabranom jeziku"
            rows="4"
          ></v-textarea>
          <v-btn
            color="primary"
            class="mt-1"
            :disabled="!(nameEng && abstractEng)"
            @click="dodajPrevod"
            small
          >
            Dodaj prijevod
          </v-btn>
        </v-col>
        <!-- <v-col
          :cols="getDeviceType === 'touch' ? 12 : 2"
          :class="
            getDeviceType === 'touch'
              ? 'd-flex justify-center align-center pt-0 mt-n3'
              : ''
          "
        >
          <v-btn
            color="primary"
            class="mt-1"
            :disabled="!(nameEng && abstractEng)"
            @click="dodajPrevod"
            small
          >
            Dodaj prijevod
          </v-btn>
        </v-col> -->
      </v-row>
    </v-form>
    <v-row>
      <v-col
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
        v-for="(prevod, i) in getPrevodi"
        :key="i"
      >
        <v-card elevation="1" class="pa-0" color="accent">
          <v-card-title
            class="d-flex justify-center align-center pa-0 pr-3 pl-3"
          >
            <h5 style="width: 80%; word-break: break-word">
              {{ prevod.naslov }}
            </h5>
            <v-spacer></v-spacer>
            <v-btn fab icon @click="removePrevod(prevod)">
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="max-height: 200px; overflow-y: auto">
            <div style="max-width: 100%">
              {{ prevod.sazetak }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dodajJezikDialog" max-width="400px">
      <v-card>
        <v-form ref="form2">
          <v-card-title style="background-color: rgb(8, 71, 118)">
            <span style="color: white">Dodaj jezik</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="close">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="noviJezik"
              outlined
              dense
              class="mt-7 ml-2 mr-2 mb-0"
              label="Unesi naziv jezika*"
              :rules="[rules.nameLangRules]"
              required
            ></v-text-field>
            <hint
              v-on:selectItem="selectJezik"
              :hints="getJeziciHints"
              :isSelectable="true"
            ></hint>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :loading="$wait.is('getJeziciHint')"
              :disabled="noviJezik === '' || !noviJezik"
              color="rgb(8, 71, 118)"
              style="color: white"
              class="mr-4 mt-n5 mb-2"
              @click="dodajJezik"
              >Dodaj jezik</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import { waitFor } from "vue-wait";
export default {
  props: ["details", "types", "noviRadDialog", "isInEdit", "selectedRad"],
  computed: {
    ...mapGetters([
      "getNoviRad",
      "getKeywords",
      "getOdabraneKljucneRijeci",
      "getJezici",
      "getOdabraniJezik",
      "getDeviceType",
      "getPrevodi",
      "getJeziciHints",
      "getTip",
    ]),
    searchKljucneRijeci: {
      set(value) {
        this.$store.dispatch("getJezici", value);
      },
      get() {
        return "";
      },
    },
    searchJezike: {
      set(value) {
        this.$store.dispatch("getKeywords", value);
      },
      get() {
        return "";
      },
    },
    nameCro: {
      set(value) {
        this.$store.dispatch("setNazivNoviRad", value);
      },
      get() {
        return this.getNoviRad.naziv;
      },
    },
    year: {
      set(value) {
        this.$store.dispatch("setGodinaNoviRad", value);
      },
      get() {
        return this.getNoviRad.godina;
      },
    },
    keywords: {
      set(value) {
        this.$store.dispatch("setOdabraneKljucneRijeci", value);
      },
      get() {
        return this.getOdabraneKljucneRijeci;
      },
    },
    abstractCro: {
      set(value) {
        this.$store.dispatch("setSazetakNoviRad", value);
      },
      get() {
        return this.getNoviRad.sazetak;
      },
    },
  },
  data: () => ({
    valid: true,
    search: null,
    nameEng: null,
    odabraniJezik: null,
    dodajJezikDialog: false,
    abstractEng: null,
    noviJezik: "",
    selected_type: '',
    rules: {
      nameRules: (v) => !!v || "Naziv rada je obavezan!",
      nameLangRules: (v) => !!v || "Naziv jezika je obavezan!",
      yearRule1: (v) => !!v || "Godina izdavanja je obavezna! U ovo polje unositi samo brojke, bez interpunkcije!",
      yearRule2: (v) =>
        (v > 1900 && v < 2100) || "Godina mora biti između 1900. i 2100.!",
      abstractRules: (v) => !!v || "Sažetak je obavezan!",
    },
  }),
  watch: {
    noviJezik(val) {
      if (val) {
        this.getHint(this, val);
      }
    },
    noviRadDialog(val) {
      if (!val) {
        this.reset();
      }
    },
  },
  methods: {
    selectJezik(jezik) {
      this.odabraniJezik = jezik;
      this.close();
    },
    getHint: _.debounce((self, value) => {
      waitFor("getJeziciHint", async function () {
        await self.$store.dispatch("getJeziciHint", value);
      }).apply(self);
    }, 500),
    removePrevod(prevod) {
      if (this.isInEdit && Object.prototype.hasOwnProperty.call(prevod, "id")) {
        this.$store.dispatch("deletePrijevodById", { prijevodId: prevod.id });
      }
      let selectedToDelete = this.getPrevodi.find((SA) => SA.id === prevod.id);
      let index = this.getPrevodi.indexOf(selectedToDelete);
      if (index > -1) {
        this.getPrevodi.splice(index, 1);
      }
    },
    removeKR(rijec) {
      this.$store.dispatch(
        "setOdabraneKljucneRijeci",
        this.keywords.filter((kr) => kr.id != rijec.id)
      );
    },
    async dodajPrevod() {
      let noviPrevod = {
        jezik_id: this.odabraniJezik.id,
        naslov: this.nameEng,
        sazetak: this.abstractEng,
      };
      if (!this.getPrevodi.includes(noviPrevod)) {
        // this.getLinks.push(noviLink)
        await this.$store.dispatch("setPrevodi", noviPrevod);
        this.getOdabraniJezik.id = null;
        this.nameEng = null;
        this.abstractEng = null;
        this.odabraniJezik = null;
      }
    },
    close() {
      this.noviJezik = "";
      this.dodajJezikDialog = false;
      this.$store.commit("SET_JEZICI_HINTS", null);
      this.$refs.form2.reset();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    openDodajJezikDialog() {
      this.dodajJezikDialog = true;
    },
    dodajJezik() {
      this.$store.dispatch("kreirajNoviJezik", this.noviJezik).then((jezik) => {
        this.dodajJezikDialog = false;
        this.$store.commit("SET_JEZICI_HINTS", null);
        this.odabraniJezik = jezik;
        this.$refs.form2.reset();
      });
    },
    clearTypes() {
      this.$emit("clearTypes");
    },
    selectTip(tip) {
      this.selected_type = tip.naziv
      this.$emit("setSelectedTip", tip);
    },
  },
};
</script>
